import { createFileRoute } from '@tanstack/react-router';
import { RewardsHistoryPage } from '../../pages/RewardsHistoryPage';
import { ProtectedRoute } from '../../../../shared/ui';

type RewardsHistorySearch = {
  payment_id?: string;
};

const ProtectedRewardsHistory = () => {
  const { payment_id } = Route.useSearch();
  return (
    <ProtectedRoute>
      <RewardsHistoryPage paymentId={payment_id} />
    </ProtectedRoute>
  );
};

export const Route = createFileRoute('/rewards/history')({
  validateSearch: (search: Record<string, unknown>): RewardsHistorySearch => ({
    payment_id:
      typeof search.payment_id === 'string' ? search.payment_id : undefined,
  }),
  component: ProtectedRewardsHistory,
});
